import { render, staticRenderFns } from "./required-documents.vue?vue&type=template&id=72868ac5&scoped=true&"
import script from "./required-documents.vue?vue&type=script&lang=js&"
export * from "./required-documents.vue?vue&type=script&lang=js&"
import style0 from "./required-documents.vue?vue&type=style&index=0&id=72868ac5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72868ac5",
  null
  
)

export default component.exports